import {
  readCanonicalTreePostDeletionHistoricalAuthority,
  type CanonicalTreePostDeletionHistoricalAuthorityReadModel,
} from './CanonicalTreePostDeletionHistoricalAuthorityReadModel';

import {
  verifyTreeRelationships,
} from './TreeRelationshipVerificationEngine';

export interface TreeCommandCenterFeed {
  readonly status:
    'healthy' | 'warning';

  readonly verified:
    boolean;

  readonly relationshipsVerified:
    number;

  readonly connectorsVerified:
    number;

  readonly authoritiesVerified:
    number;

  readonly generatedAt:
    string;

  readonly historicalAuthorityReadModel:
    CanonicalTreePostDeletionHistoricalAuthorityReadModel;
}

export function getTreeCommandCenterFeed():
  TreeCommandCenterFeed {
  const verification =
    verifyTreeRelationships();

  const historicalAuthorityReadModel =
    readCanonicalTreePostDeletionHistoricalAuthority();

  return Object.freeze({
    status:
      verification.passed
        ? 'healthy'
        : 'warning',

    verified:
      verification.passed,

    relationshipsVerified:
      verification.relationshipsVerified,

    connectorsVerified:
      verification.connectorsVerified,

    authoritiesVerified:
      verification.authoritiesVerified,

    generatedAt:
      verification.verifiedAt,

    historicalAuthorityReadModel,
  });
}
